/** Русское склонение по числу: 1 тренд · 2–4 тренда · 5+ трендов (11–14 — всегда «много»). */
export function pluralRu(n: number, one: string, few: string, many: string): string {
	const m10 = n % 10
	const m100 = n % 100
	if (m10 === 1 && m100 !== 11) return one
	if (m10 >= 2 && m10 <= 4 && (m100 < 12 || m100 > 14)) return few
	return many
}

/** «N трендов» для бейджа мульти-тренда на плитках (22.10). */
export const trendsLabel = (n: number): string => `${n} ${pluralRu(n, 'тренд', 'тренда', 'трендов')}`
